import React from "react";
import { connect } from "react-redux";
import Page from "../../components/shared/pages/Page";
import TableHead from "../../components/shared/table/CouponTableHead";
import Loading from "../../components/shared/loaders/Loading";
import { fullDate } from "../../helpers/DateTimeHelper";
import PaginationButtons from "../../components/shared/buttons/PaginationButtons";
import store from "../../Store";
import { setDashboardMenu } from "../../routes/main-route/MainRoute-Actions";
import ResponsiveModalForm from "../../components/shared/modals/ResponsiveModalForm";
import axios from "axios";
import { apiBaseUrl } from "../../helpers/UrlHelper";
import { loginToken } from "../../helpers/LocalStorageHelper";
import { ucFirst } from "../../helpers/StringHelper";
import ViewSingleSite from "../failed-site-transactions/ViewSingleSite";
import UpdateStatus from "../failed-site-transactions/UpdateStatus";
import OrganizationSideMenu from "../organization/OrganizationSideMenu";
import OrganizationFailedFilters from "./OrganizationFailedFilters";
import OrganizationFailedWorker from "./OrganizationFailedWorker";
import { withRouter } from "react-router-dom";
import {
  toggleFailedOrganizationModal,
  toggleFailedOrganizationStatusModal,
  toggleOrganizationFailedSiteFilter,
} from "./OgranizationFailed-Action";
import { handleError } from "../../helpers/ErrorHelper";

class OrganizationFailedSite extends React.Component {
  state = {
    selectedTransaction: null,
    modalLoading: false,
    id: null,
  };

  componentDidMount() {
    document.querySelector("body").classList.add("organization-dashboard");
    store.dispatch(setDashboardMenu("organization"));
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    document.querySelector("body").classList.remove("organization-dashboard");
  }

  async handleOpenModal(id) {
    this.setState({ modalLoading: true, selectedTransaction: null });

    store.dispatch(toggleFailedOrganizationModal({ mode: true }));
    axios({
      url: apiBaseUrl(`admin/failed-site-transactions/${id}`),
      method: "get",
      dataType: "json",
      headers: { Authorization: "Bearer " + loginToken() },
    })
      .then((res) => {
        this.setState({
          selectedTransaction: res?.data?.data,
          modalLoading: false,
        });
      })
      .catch((err) => {
        this.setState({ modalLoading: false });
        handleError(err?.data?.message);
      });
  }

  toggleSort = (field) => {
    store.dispatch(
      toggleOrganizationFailedSiteFilter(
        {
          target: { name: `sort_by`, value: field },
        },
        this.props?.match?.params?.history,
        this.props?.match?.params?.id
      )
    );
  };

  render() {
    const {
      fields,
      params,
      modal,
      lists,
      getOrganizationFailedTnx,
      pages,
      status_modal,
    } = this.props;
    const { processing, error } = getOrganizationFailedTnx;

    if (error) {
      this.props.history.push("/");
    }

    return (
      <Page title="Sites" processing={processing}>
        <div className="page-content">
          <div className="organizations-sidebar">
            <OrganizationSideMenu processing={processing} />
          </div>
          <div className="content-section">
            <OrganizationFailedFilters
              title="Failed Organizations Transactions"
              organization_id={this.props.match.params.id}
            />
            <div className="table-block table-responsive pr-60">
              <table className="table table-striped  ">
                <TableHead
                  fields={fields}
                  params={params}
                  noActions={true}
                  onClick={this.toggleSort}
                />
                <tbody>
                  {processing ? (
                    <td colSpan="6" className="text-center">
                      <Loading />
                    </td>
                  ) : lists && lists.length ? (
                    lists.map((list) => {
                      return (
                        <tr key={list.id}>
                          <td>{list.job_id}</td>
                          <td>{list.event}</td>
                          <td>{fullDate(list.created_at)}</td>
                          <td>{fullDate(list.updated_at)}</td>
                          <td>{ucFirst(list.status)}</td>
                          <td>
                            {
                              <div className="dropdown dropdown-alt text-center">
                                <span
                                  className="dropdown-toggle"
                                  data-toggle="dropdown"
                                >
                                  <span className="icon-more" />
                                </span>
                                <div className="dropdown-menu">
                                  <a
                                    href="javascript:void(0);"
                                    onClick={() =>
                                      this.handleOpenModal(list.id)
                                    }
                                  >
                                    View
                                  </a>
                                  <a
                                    href="javascript:void(0);"
                                    className={`update-status`}
                                    onClick={() => {
                                      store.dispatch(
                                        toggleFailedOrganizationStatusModal({
                                          mode: true,
                                        })
                                      );
                                      this.setState({ id: list.id });
                                    }}
                                  >
                                    Update Status
                                  </a>
                                </div>
                              </div>
                            }
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No Failed Site Transactions Available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <ResponsiveModalForm
                visible={modal.mode}
                closeModal={() =>
                  store.dispatch(toggleFailedOrganizationModal())
                }
              >
                {this.state.modalLoading ? (
                  <div className="text-center">
                    <Loading />
                  </div>
                ) : (
                  <ViewSingleSite
                    data={this.state.selectedTransaction}
                    title="Failed Organization Transactions"
                  />
                )}
              </ResponsiveModalForm>
              <ResponsiveModalForm
                visible={status_modal.mode}
                closeModal={() =>
                  store.dispatch(toggleFailedOrganizationStatusModal())
                }
              >
                <UpdateStatus id={this.state.id} title="Failed Organization" />
              </ResponsiveModalForm>
            </div>
            {lists && lists.length ? (
              <>
                <div
                  className="fixed-footer pr-60"
                  id="inside-organization-pagination"
                >
                  <PaginationButtons
                    pages={pages}
                    processing={processing}
                    fetchAction={toggleOrganizationFailedSiteFilter}
                  />
                </div>
              </>
            ) : null}
          </div>
        </div>
        <OrganizationFailedWorker />
      </Page>
    );
  }
}

function mapStateToProps(state) {
  const { organizationFailedTnxList, getOrganizationFailedTnx } = state;
  const { success } = getOrganizationFailedTnx;
  const { params, fields, modal, status_modal } =
    organizationFailedTnxList.data;

  const lists = success && success.data;

  const current_page = success && success.current_page;
  const last_page = success && success.last_page;
  const total = success && success.total;
  const pages = { current_page, last_page, total };

  return {
    getOrganizationFailedTnx,
    lists,
    modal,
    pages,
    params,
    fields,
    status_modal,
  };
}

export default withRouter(connect(mapStateToProps)(OrganizationFailedSite));
